import React from 'react';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import {DownloadOutlined} from '@ant-design/icons';
import {Button} from 'antd';
import PropTypes from 'prop-types';

const ExportCSV_PJ = ({csvData, fileName, tipoCandidatosBusqueda, tipoCandidatura, setCargandoExcel}) => {
	//console.log("TIPO CANDIDATURAX", tipoCandidatura);
	const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
	const fileExtension = '.xlsx';

	const buildRutaFicha = (candidato) => {
		if (candidato.estatusVal == 1 || candidato.validaCuestionario == 1)
			return (
				`${process.env.REACT_APP_EXCEL_URL}` +
				`${process.env.REACT_APP_RUTA_ARCHIVOS}` +
				candidato.nombreCandidato.replaceAll(' ', '_') +
				'_' +
				candidato.idCandidato +
				'.pdf'
			);
		return '';
	};
	const buildRutaFichaSup = (candidato) => {
		if (candidato.estatusValSup == 1 || candidato.validaCuestionarioSup == 1)
			return (
				`${process.env.REACT_APP_EXCEL_URL}` +
				`${process.env.REACT_APP_RUTA_ARCHIVOS}` +
				candidato.nombreSuplente.replaceAll(' ', '_') +
				'_' +
				candidato.idCandidatoSup +
				'.pdf'
			);
		return '';
	};
	const buildRutaFichaSupSinPro = (candidato) => {
		if (candidato.estatusVal == 1 || candidato.validaCuestionario == 1)
			return (
				`${process.env.REACT_APP_EXCEL_URL}` +
				`${process.env.REACT_APP_RUTA_ARCHIVOS}` +
				candidato.nombreSuplente.replaceAll(' ', '_') +
				'_' +
				candidato.idCandidatoSup +
				'.pdf'
			);
		return '';
	};

	const exportToCSV = (csvData, fileName, tipoCandidatosBusqueda, tipoCandidatura) => {
		
		setCargandoExcel(true);
		let csvDataShow = [];
		let header = [];

		//Todos los excel seran iguales para PJ las banderas de  tipoCandidatosBusqueda tipoCandidatura
		//se dejan para futuras referencias o cambios
		//if (tipoCandidatura == 1) {
		//if (tipoCandidatosBusqueda === 'P') {

		csvData.forEach((element) => {
			
			let poder = "";
			if(Array.isArray(element.poderPostula)){
				poder = element.poderPostula.map((numero) => {
					if (numero === 1) return "Poder Ejecutivo";
					if (numero === 2) return "Poder Legislativo";
					if (numero === 3) return "Poder Judicial";
					if (numero === 4) return "En Funciones";
				  	return "La candidatura no proporcionó información."; // Para el caso en que no haya coincidencia
				})
				.join(", ");
			}else{
				poder = "La candidatura no proporcionó información.";
			}

			csvDataShow = [
				...csvDataShow,
				{
					'Poder de la Unión': poder,
					'Persona Candidata': element.nombreCandidato,
					'CurriculumV Persona Candidata': buildRutaFicha(element),
				},
			];
		});
		header = ['Poder de la Unión', 'Persona Candidata', 'CurriculumV Persona Candidata'];

		const ws = XLSX.utils.json_to_sheet(csvDataShow, {header});
		const wb = {Sheets: {data: ws}, SheetNames: ['data']};

		const excelBuffer = XLSX.write(wb, {bookType: 'xlsx', type: 'array'});
		const data = new Blob([excelBuffer], {type: fileType});
		FileSaver.saveAs(data, fileName + fileExtension);
		setCargandoExcel(false);

	};

	return (
		<div>
			<Button
				key="descargar"
				type="primary"
				onClick={(e) => {
					exportToCSV(csvData, fileName, tipoCandidatosBusqueda, tipoCandidatura);
				}}
				className="primary-button"
			>
				<DownloadOutlined />
				Descargar
			</Button>
		</div>
	);
};

ExportCSV_PJ.propTypes = {};

export default ExportCSV_PJ;
